import { algoliasearch } from 'algoliasearch'

import type { TProCategory } from '@/interfaces/user'

export type TService = TProCategory & {
  userId: string
  genres: string[]
  clients: string[]
}

const config = {
  appId: process.env.NEXT_PUBLIC_ALGOLIA_APP_ID || '',
  searchKey: process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_KEY || '',
}

const client = algoliasearch(config.appId, config.searchKey)

export const analyticsClient = client.initAnalytics({ region: 'us' })

export default client
